//['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', '|', 'color', 'emoticons', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', 'insertHR', '-', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', 'undo', 'redo', 'clearFormatting', 'selectAll', 'html']
//https://www.froala.com/wysiwyg-editor/docs/plugins
const toolbarButtons = [
  'CLEX_Keyword',
  'CLEX_InsertDivider', '|',
  'paragraphFormat',
  'bold', 'italic', 'underline',
  '|',
  'formatOL', 'formatUL',
  '|',
  'undo', 'redo', 'html', 'insertImage',
];

const config = {
  toolbarButtons:   toolbarButtons,
  toolbarButtonsMD: toolbarButtons,
  toolbarButtonsSM: toolbarButtons,
  toolbarButtonsXS: toolbarButtons,
  paragraphFormat: { h2: 'Heading 1', h3: 'Heading 2', n: 'Normal' },
  htmlExecuteScripts: false,
  pastePlain: true,

  // Defaults (extended below)
  htmlAllowedTags:        ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
  htmlAllowedEmptyTags:   ['object', 'video'],
  htmlDoNotWrapTags: ['script', 'style'],
  htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'alt', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'multiple', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'width', 'wrap'],
  pasteDeniedTags: ['sup'],
  shortcutsEnabled: ['show', 'bold', 'italic', 'underline', 'strikeThrough', 'indent', 'outdent', 'undo', 'redo', 'insertImage', 'CLEX_InsertDivider', 'CLEX_Keyword'],

  // ['imageReplace', 'imageAlign', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize'],
  imageEditButtons: ['CLEX_ConvertImageToMicroNote', '|', 'imageAlign', 'imageDisplay', 'imageRemove', '|'],

}


/**
 * Extend allowed tags with custom ones
 */

/*
examples:
<hr is="divider">
<keyword>Hello World</keyword>
*/

config.htmlAllowedTags      = config.htmlAllowedTags.concat(['keyword'])
config.htmlAllowedEmptyTags = config.htmlAllowedEmptyTags.concat([])
config.htmlDoNotWrapTags    = config.htmlDoNotWrapTags.concat(['keyword'])
config.htmlAllowedAttrs     = config.htmlAllowedAttrs.concat(['is']) // is="xxx" is another way to define a vue element, ie. <hr is="divider">

export default config;



// WEBPACK FOOTER //
// ./src/components/froala-editor/config/lecture-note-editor.js